export default __webpack_public_path__ + "static/media/calibri-bold-italic.d99df162.ttf";